import React from 'react';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { useCompanySportTerminology } from '../../lib/stores/company.store';
import { pluralTerm } from '../../lib/helpers/term.helper';
import { SportTerminology } from '../../lib/types';
import { FormatTemplateCountChips } from './format-template-count-chips.component';
import { messages } from './format-template.messages';

interface IFormatTemplatePillsProps {
  template: IFormatTemplate;
  // The band being applied, when one is selected — its range and counts replace the
  // template-wide ones, which span every band of a banded template.
  band?: IFormatTemplateBand | null;
  isRecommended?: boolean;
  showAgeGroups?: boolean;
  // Session total for a resolved band. A CATALOG template can't answer it on its own — the
  // count depends on which band the roster lands in — so it arrives from the preview.
  totalAssessmentSessions?: number | null;
}

export const FormatTemplatePills: React.FC<IFormatTemplatePillsProps> = ({
  template,
  band,
  isRecommended = false,
  showAgeGroups = false,
  totalAssessmentSessions,
}) => {
  const termLookup = useCompanySportTerminology();

  // Not memoized: a handful of cheap nullish reads, none feeding a hook dependency array.
  const rangeSource = band ?? template;
  const hasPlayerRange = rangeSource.minPlayers != null && rangeSource.maxPlayers != null;
  const skaterWord = pluralTerm(termLookup[SportTerminology.SKATER]).toLowerCase();
  const sessionTotal = totalAssessmentSessions ?? band?.totalAssessmentSessions ?? template.totalAssessmentSessions;
  const teamCount = (band?.teamOutcomes ?? template.teamOutcomes)?.length;

  return (
    <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
      {isRecommended && <Chip label={<IntlMsg {...messages.recommended} />} size="small" color="primary" />}
      {showAgeGroups && template.ageGroupBuckets?.map(b => <Chip key={b} label={b} size="small" />)}
      {hasPlayerRange && (
        <Chip
          label={<IntlMsg {...messages.playerRange} values={{ min: rangeSource.minPlayers, max: rangeSource.maxPlayers, skaterWord }} />}
          size="small"
        />
      )}
      <FormatTemplateCountChips sessionTotal={sessionTotal} teamCount={teamCount} />
    </Box>
  );
};
